export default "__VITE_ASSET__Bf2Y_z5E__"